import { Col, Button } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { SecondaryButton } from "../CustomButtons/CustomButtons";
import { useVolSurfaceControlTable } from "contexts/VolSurfaceControlTableContext";

export default function WholeSurface({
    dark_Theme,
    onBiasChange,
    disabledCondition,
    batchUpdate
}) {
  const { lockedData } = useVolSurfaceControlTable();
  return (
    <>
      <Col span={3}> Whole Surface: </Col>
      <Col>
        <SecondaryButton
          icon={<UpOutlined />}
          // className={dark_Theme ? "graph-btn" : ""}
          onClick={() => onBiasChange(true)}
          disabled={disabledCondition || batchUpdate || lockedData?.is_locked}
        />
        <SecondaryButton
          icon={<DownOutlined />}
          // className={dark_Theme ? "graph-btn" : ""}
          onClick={() => onBiasChange(false)}
          disabled={disabledCondition || batchUpdate || lockedData?.is_locked}
        />
      </Col>
    </>
  );
}
